import { ResponsivePie } from '@nivo/pie'

const personColors = {
  Staff: '#ff7a00',
  Parent: '#26854d',
  Student: '#006c6d',
  Member: '#8b9000',
}

const prepChartData = (t) => ({
  id: t.type,
  color: personColors[t.type],
  label: t.type,
  value: t.count,
})

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const PeoplePie = ({ people }) => {
  let filteredPeople = people.filter((e) => e.type)
  const data = filteredPeople.map(prepChartData)
  return (
    <ResponsivePie
      data={data}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      innerRadius={0.54}
      padAngle={0.7}
      cornerRadius={3}
      colors={(i) => personColors[i.id]}
      borderWidth={1}
      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
      radialLabelsSkipAngle={10}
      radialLabelsTextXOffset={6}
      radialLabelsTextColor="#333333"
      radialLabelsLinkOffset={0}
      radialLabelsLinkDiagonalLength={16}
      radialLabelsLinkHorizontalLength={24}
      radialLabelsLinkStrokeWidth={1}
      radialLabelsLinkColor={{ from: 'color' }}
      slicesLabelsSkipAngle={10}
      slicesLabelsTextColor="#fff"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      defs={[
        {
          id: 'dots',
          type: 'patternDots',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.5)',
          size: 1,
          padding: 2,
          stagger: true,
        },
        {
          id: 'lines',
          type: 'patternLines',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.5)',
          rotation: -45,
          lineWidth: 3,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: 'Staff',
          },
          id: 'dots',
        },
        {
          match: {
            id: 'Parent',
          },
          id: 'dots',
        },
        {
          match: {
            id: 'Student',
          },
          id: 'dots',
        },
        {
          match: {
            id: 'Member',
          },
          id: 'dots',
        },
      ]}
      legends={[]}
    />
  )
}

// const legends = [
//   {
//     anchor: 'left',
//     direction: 'column',
//     translateY: 56,
//     itemWidth: 100,
//     itemHeight: 27,
//     itemTextColor: '#999',
//     symbolSize: 18,
//     symbolShape: 'circle',
//     effects: [
//       {
//         on: 'hover',
//         style: {
//           itemTextColor: '#000',
//         },
//       },
//     ],
//   },
// ]

export default PeoplePie
